import { showsSearchAndAi } from '@/helpers/aiReadableStorefront'
import { AI_CONNECTOR_CAPABILITY } from '@/helpers/connectedApps'
import { PARSLEY_CAPABILITY } from '@/helpers/parsley'

export const SETTINGS_ROOT = '/settings'
export const INTEGRATIONS_PATH = '/settings/integrations'
export const SEARCH_AND_AI_PATH = '/settings/search-and-ai'
export const ORDERING_AND_DELIVERY_PATH = '/settings/ordering-delivery'

export const ROLES_HOME = '/users/roles'
export const NEW_ROLE = `${ROLES_HOME}/new`
export const rolePath = id => `${ROLES_HOME}/${id}`

export function buildSettingsTabs({
  hasFullAccess = false,
  capabilities = [],
  canManageUsers = false,
  isCatering = false
} = {}) {
  return [
    { id: 'account', name: 'Account', to: '/settings/account', match: ['/settings/account'] },
    ...(hasFullAccess
      ? [
          {
            id: 'notifications',
            name: 'Notifications',
            to: '/settings/notifications',
            match: ['/settings/notifications']
          }
        ]
      : []),
    { id: 'company', name: 'Company settings', to: '/settings/company', match: ['/settings/company'] },
    ...(hasFullAccess && isCatering
      ? [
          {
            id: 'ordering-delivery',
            name: 'Ordering & delivery',
            to: ORDERING_AND_DELIVERY_PATH,
            match: [ORDERING_AND_DELIVERY_PATH]
          }
        ]
      : []),
    ...(showsSearchAndAi({ hasFullAccess, capabilities })
      ? [{ id: 'search-and-ai', name: 'Search & AI', to: SEARCH_AND_AI_PATH, match: [SEARCH_AND_AI_PATH] }]
      : []),
    ...(hasFullAccess
      ? [{ id: 'office-hours', name: 'Office hours', to: '/settings/office-hours', match: ['/settings/office-hours'] }]
      : []),
    ...(canManageUsers
      ? [{ id: 'users', name: 'Users & permissions', to: ROLES_HOME, match: [ROLES_HOME, '/roles'] }]
      : []),
    ...(hasFullAccess
      ? [{ id: 'billing', name: 'Billing & payouts', to: '/settings/billing', match: ['/settings/billing'] }]
      : []),
    ...(hasFullAccess &&
    (capabilities.includes('paytronix') ||
      capabilities.includes(PARSLEY_CAPABILITY) ||
      capabilities.includes(AI_CONNECTOR_CAPABILITY))
      ? [{ id: 'integrations', name: 'Integrations', to: INTEGRATIONS_PATH, match: [INTEGRATIONS_PATH] }]
      : [])
  ]
}

export function settingsTabForPath(tabs, path) {
  return tabs.find(tab => tab.match.some(prefix => path === prefix || path.startsWith(prefix + '/')))?.id ?? null
}

export function firstSettingsPath(tabs) {
  return tabs[0]?.to ?? '/settings/account'
}
